import { render, staticRenderFns } from "./SiteArticles.vue?vue&type=template&id=46380233&"
import script from "./SiteArticles.vue?vue&type=script&lang=js&"
export * from "./SiteArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports